import type { SecondaryOrderStatePath } from 'state/secondaryMarket/secondaryMarket.model';
import type { Kyc } from 'state/secondaryMarket/shared/kyc/kyc.model';
import type { AppState } from 'state/state.model';

export const kycSelectorsFactory = (stateType: Exclude<SecondaryOrderStatePath, 'cpOrder'>) => {
  const selectKycState = (state: AppState, tabId: string): Kyc => {
    return state.secondaryMarket[stateType].kyc[tabId];
  };
  return {
    getKycStatusScore: (appState: AppState, tabId: string) => {
      const state = selectKycState(appState, tabId);
      return state?.data?.score;
    },
    getKycStatusDetails: (appState: AppState, tabId: string) => {
      const state = selectKycState(appState, tabId);
      return state?.data?.details;
    },
  };
};

export type KycSelectors = ReturnType<typeof kycSelectorsFactory>;
